import Page from '../../components/Page';
import { observer } from 'mobx-react-lite';
import { Route } from 'react-router-dom';
import Paths from '../../constants/paths';
import ErrorMessages from '../../components/ErrorMessages.js';
import ParkingStats from './ParkingStats';

const ParkingStatsTab = ({ store }) => {
    return (
        <Page loading={!store.dataLoaded}>
            <div style={{ marginLeft: '2.5%' }}>
                <ErrorMessages messages={store.error} />
            </div>
            <Route exact path={Paths.PARKING_STATS}>
                <ParkingStats store={store} />
            </Route>
        </Page>
    );
};

export default observer(ParkingStatsTab);
